import { render, staticRenderFns } from "./GameListSlider.vue?vue&type=template&id=6520e2bd&scoped=true"
import script from "./GameListSlider.vue?vue&type=script&lang=js"
export * from "./GameListSlider.vue?vue&type=script&lang=js"
import style0 from "./GameListSlider.vue?vue&type=style&index=0&id=6520e2bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520e2bd",
  null
  
)

export default component.exports